"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateStyles = exports.stateStyles = void 0;
var react_1 = require("react");
var theme_1 = require("../../theme");
exports.stateStyles = {
    upcoming: {
        container: 'transparent',
        indicatorContainer: 'disabled',
        hover: 'base',
    },
    current: {
        container: 'base',
        subTitle: 'info',
        indicatorContainer: 'active',
        indicator: 'primary',
    },
    completed: {
        container: 'transparent',
        hover: 'base',
        subTitle: 'success',
    },
    skipped: {
        container: 'base',
        hover: 'base',
        subTitle: 'attention',
    },
};
var useStateStyles = function (state, branding) {
    var _a = (0, react_1.useState)(exports.stateStyles[state]), styles = _a[0], setStyles = _a[1];
    var bgColors = (0, theme_1.useBackgroundColors)(branding);
    var bgStateColors = (0, theme_1.useBackgroundStateColors)(branding);
    var bgStateActiveColors = (0, theme_1.useBackgroundStateActiveColors)(branding);
    var borderColors = (0, theme_1.useBorderColors)(branding);
    (0, react_1.useEffect)(function () {
        setStyles({
            container: state === 'current'
                ? bgStateActiveColors.base
                : bgColors[exports.stateStyles[state].container],
            hover: exports.stateStyles[state].hover
                ? bgStateColors[exports.stateStyles[state].hover]
                : '',
            title: state === 'upcoming' ? 'disabled' : 'weaker',
            subTitle: exports.stateStyles[state].subTitle,
            indicatorContainer: exports.stateStyles[state].indicatorContainer
                ? borderColors[exports.stateStyles[state].indicatorContainer]
                : '',
            indicator: exports.stateStyles[state].indicator
                ? bgColors[exports.stateStyles[state].indicator]
                : '',
        });
    }, [state]);
    return styles;
};
exports.useStateStyles = useStateStyles;
